import React from 'react';
import PropTypes from 'prop-types';

const Image = props => {
  const { imgSrc, className, altText } = props;
  return <img src={imgSrc} className={className} alt={altText} />;
};
export default Image;

Image.defaultProps = {
  altText: '',
  className: '',
  imgSrc: '',
};

Image.propTypes = {
  altText: PropTypes.string,
  className: PropTypes.string,
  imgSrc: PropTypes.string,
};
